import { useState } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { fmtINRFull, fmtINR } from "@/lib/format";

const rows = (file = {}, before = {}, after) => Object.keys(file).sort().map((k) => ({
  key: k, file: file[k] || 0, before: before[k] || 0, after: after ? after[k] || 0 : undefined,
}));

const StoreGaps = ({ gap, applied }) => {
  const [all, setAll] = useState(false);
  const list = rows(gap.file_by_store, gap.portal_by_store, applied ? gap.portal_by_store_after : null)
    .map((r) => ({ ...r, gap: r.file - (applied ? r.after : r.before) }))
    .sort((a, b) => Math.abs(b.gap) - Math.abs(a.gap));
  const shown = all ? list : list.slice(0, 12);
  return (
    <div data-testid="reco-store-gaps">
      <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1">Gap by store (largest first)</div>
      <table className="w-full text-xs">
        <thead><tr className="text-left text-neutral-500 border-b">
          <th className="py-1 pr-3">Store</th><th className="pr-3 text-right">File</th><th className="pr-3 text-right">Portal {applied ? "now" : ""}</th><th className="text-right">Gap</th>
        </tr></thead>
        <tbody>{shown.map((r) => (
          <tr key={r.key} className="border-b border-black/5" data-testid={`reco-store-gap-${r.key}`}>
            <td className="py-1 pr-3"><span className="font-mono">{r.key}</span> {gap.store_names?.[r.key]}</td>
            <td className="pr-3 text-right">{fmtINRFull(r.file)}</td>
            <td className="pr-3 text-right">{fmtINRFull(applied ? r.after : r.before)}</td>
            <td className={`text-right ${Math.abs(r.gap) > 1 ? "text-rose-700 font-medium" : "text-emerald-700"}`}>{fmtINRFull(r.gap)}</td>
          </tr>))}
        </tbody>
      </table>
      {list.length > 12 && <button className="k-btn k-btn-ghost k-btn-sm mt-1" onClick={() => setAll(!all)} data-testid="reco-store-gaps-toggle">{all ? "Show fewer" : `Show all ${list.length} stores`}</button>}
    </div>
  );
};

export const RecoGapTrend = ({ gap, applied }) => {
  if (!gap?.file_daily) return null;
  const data = rows(gap.file_daily, gap.portal_daily, applied ? gap.portal_daily_after : null).map((r) => ({ ...r, day: r.key.slice(8) }));
  return (
    <div className="space-y-4" data-testid="reco-gap-trend">
      <div className="text-[10px] uppercase tracking-widest text-neutral-500">Day-by-day: file sales vs portal sales</div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
            <XAxis dataKey="day" tick={{ fontSize: 11 }} />
            <YAxis tickFormatter={fmtINR} tick={{ fontSize: 11 }} width={70} />
            <Tooltip formatter={(v) => fmtINRFull(v)} labelFormatter={(l, p) => p?.[0]?.payload?.key || l} />
            <Legend />
            <Bar dataKey="file" name="File" fill="#6b1d2a" />
            <Bar dataKey="before" name="Portal before" fill="#c9b37e" />
            {applied && <Line dataKey="after" name="Portal after apply" stroke="#0f766e" strokeWidth={2} dot={false} />}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <StoreGaps gap={gap} applied={applied} />
    </div>
  );
};
